module.exports = "    ,.--.,    \r\n  ,`      ..  \r\n /     ,-`  \\ \r\n|    .` _    .\r\n| ,-`  /  ,-`|\r\n-`    ` .`   |\r\n \\   ,-`    / \r\n  '-`     ,-  \r\n    `'--'`    "


//////////////////
// WEBPACK FOOTER
// ./src/res/wheelLeft.txt
// module id = 78
// module chunks = 0